export default __webpack_public_path__ + "static/media/Backback-Remove.42915023.svg";